import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TRAVELPAYOUTS_TOKEN = 'dd0c16e11df0e44551f2356773ebbdd7';
// Paste your token from Step 1
const WHATSAPP_NUMBER = '447123456789';

export default function FlightPriceChecker() {
  const [loading, setLoading] = useState(false);
  const [prices, setPrices] = useState([]);
  const [form, setForm] = useState({
    origin: 'LON', // London
    destination: 'NYC', // New York
    departDate: '2025-12',
    currency: 'GBP'
  });

  const searchFlights = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPrices([]);

    try {
      // Travelpayouts Data API - Shows cached/historical prices (FREE)
      const url = `https://api.travelpayouts.com/aviasales/v3/prices_for_dates?origin=${form.origin}&destination=${form.destination}&departure_at=${form.departDate}&currency=${form.currency}&token=${TRAVELPAYOUTS_TOKEN}`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.success && data.data) {
        setPrices(data.data.slice(0, 10)); // Show top 10 results
      } else {
        alert('No prices found for this route');
      }
    } catch (error) {
      console.error('API Error:', error);
      alert('Failed to fetch prices. Check your API token.');
    } finally {
      setLoading(false);
    }
  };

  const handleWhatsApp = (price) => {
    const msg = `Hi! I'm interested in this flight:\n\n${form.origin} → ${form.destination}\nEstimated price: £${price.value}\nDeparture: ${price.depart_date}\nReturn: ${price.return_date}\n\nCan you help me book this?`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`);
  };

  return (
    <>
      <Navbar />
      <div style={{ background: '#fff', minHeight: '100vh', padding: '40px 20px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          
          {/* Header */}
          <h1 style={{ fontSize: 36, fontWeight: 800, marginBottom: 10, color: '#124' }}>
            ✈️ Flight Price Checker
          </h1>
          <p style={{ fontSize: 16, color: '#666', marginBottom: 30 }}>
            Check estimated flight prices based on recent searches
          </p>

          {/* Disclaimer */}
          <div style={{ 
            background: '#fff3cd', 
            padding: 15, 
            borderRadius: 8, 
            marginBottom: 30,
            border: '1px solid #ffc107'
          }}>
            <strong>⚠️ Important:</strong> Prices shown are estimates from recent historical data. 
            Final prices may vary. Contact our agents for live quotes and instant booking.
          </div>

          {/* Search Form */}
          <form onSubmit={searchFlights} style={{ 
            background: '#f5f7fa', 
            padding: 30, 
            borderRadius: 12, 
            marginBottom: 30 
          }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 15 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 5, fontWeight: 600 }}>From (Airport Code)</label>
                <input 
                  type="text" 
                  placeholder="e.g., LON" 
                  value={form.origin}
                  onChange={e => setForm({...form, origin: e.target.value.toUpperCase()})}
                  style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ddd' }}
                  required
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 5, fontWeight: 600 }}>To (Airport Code)</label>
                <input 
                  type="text" 
                  placeholder="e.g., NYC" 
                  value={form.destination}
                  onChange={e => setForm({...form, destination: e.target.value.toUpperCase()})}
                  style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ddd' }}
                  required
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 5, fontWeight: 600 }}>Month (YYYY-MM)</label>
                <input 
                  type="text" 
                  placeholder="2025-12" 
                  value={form.departDate}
                  onChange={e => setForm({...form, departDate: e.target.value})}
                  style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ddd' }}
                  required
                />
              </div>
            </div>
            <button 
              type="submit"
              disabled={loading}
              style={{ 
                marginTop: 20,
                padding: '12px 30px', 
                background: '#4282ff', 
                color: 'white', 
                border: 'none',
                borderRadius: 8,
                fontSize: 16,
                fontWeight: 700,
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? '🔍 Searching...' : '🔍 Check Prices'}
            </button>
          </form>

          {/* Results */}
          {prices.length > 0 && (
            <div>
              <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 20 }}>
                💡 Estimated Prices Found
              </h2>
              <div style={{ display: 'grid', gap: 20 }}>
                {prices.map((price, idx) => (
                  <div 
                    key={idx}
                    style={{ 
                      background: '#fff', 
                      border: '1px solid #ddd',
                      borderRadius: 12,
                      padding: 20,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <div>
                      <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
                        {price.origin} → {price.destination}
                      </div>
                      <div style={{ fontSize: 14, color: '#666', marginBottom: 4 }}>
                        📅 Departure: {price.depart_date}
                      </div>
                      <div style={{ fontSize: 14, color: '#666', marginBottom: 4 }}>
                        🔄 Return: {price.return_date}
                      </div>
                      <div style={{ fontSize: 14, color: '#666' }}>
                        ✈️ Airline: {price.airline}
                      </div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 28, fontWeight: 900, color: '#228468', marginBottom: 10 }}>
                        £{price.value}
                      </div>
                      <button
                        onClick={() => handleWhatsApp(price)}
                        style={{
                          padding: '10px 20px',
                          background: '#25d366',
                          color: 'white',
                          border: 'none',
                          borderRadius: 6,
                          fontSize: 14,
                          fontWeight: 700,
                          cursor: 'pointer'
                        }}
                      >
                        📱 Book via WhatsApp
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Help Section */}
          <div style={{ marginTop: 40, padding: 20, background: '#f0f9ff', borderRadius: 8 }}>
            <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 10 }}>
              ℹ️ How to use Airport Codes
            </h3>
            <p style={{ marginBottom: 10 }}>Enter 3-letter IATA airport codes:</p>
            <ul style={{ marginLeft: 20 }}>
              <li>London: LON (all airports) or LHR (Heathrow)</li>
              <li>New York: NYC (all) or JFK (Kennedy)</li>
              <li>Paris: PAR or CDG</li>
              <li>Dubai: DXB</li>
              <li>Barcelona: BCN</li>
            </ul>
            <p style={{ marginTop: 10 }}>
              Need help? <a href={`https://wa.me/${WHATSAPP_NUMBER}`} style={{ color: '#4282ff' }}>Contact our agents</a>
            </p>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
}
